__turbopack_context__.v({
  "active": "TypeFilter-module__XtvZTa__active",
  "item": "TypeFilter-module__XtvZTa__item",
  "itemActive": "TypeFilter-module__XtvZTa__itemActive",
  "list": "TypeFilter-module__XtvZTa__list",
  "popIn": "TypeFilter-module__XtvZTa__popIn",
  "popoverContent": "TypeFilter-module__XtvZTa__popoverContent",
  "trigger": "TypeFilter-module__XtvZTa__trigger",
});
